<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
      <a class="navbar-brand" href="javascript:void(0)">Wallet History</a>
    </div>
</nav>
<hr/>
<div class="row">
    <div class="col-12">
        <app-table #table></app-table>
    </div>
</div>